import * as React from 'react';
import { IModifiers } from '../../data/IModifiers';
import { MotionSourceType } from '../../motion/MotionSource';
import { generateClassName } from '../../utils';

type Props = {
  icon:
    | 'options'
    | 'download'
    | 'pause'
    | 'play'
    | 'rewind'
    | 'mute'
    | 'unmute'
    | 'text'
    | 'timeline'
    | 'edit'
    | 'replace'
    | 'delete'
    | 'delete-color'
    | 'effect'
    | 'plus'
    | 'check'
    | 'x'
    | 'zoom-in'
    | 'zoom-out'
    | 'search'
    | 'undo'
    | 'redo'
    | MotionSourceType;
  active?: boolean;
  modifiers?: IModifiers;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  iconSize?: number;
};
export type ButtonIconProps = Props & React.HTMLProps<HTMLButtonElement>;

export const ButtonIcon = React.forwardRef<HTMLButtonElement, ButtonIconProps>(
  (props, ref) => {
    const {
      active,
      modifiers,
      onMouseEnter,
      onMouseLeave,
      onFocus,
      disabled,
      onClick,
      icon,
      iconSize
    } = props;
    const scale = iconSize !== undefined ? iconSize / 20 : 1;
    return (
      <button
        className={
          generateClassName('icon', modifiers) +
          (active ? ' icon--active' : '') +
          ' icon--' +
          icon
        }
        onClick={e => {
          if (e.nativeEvent.detail === 0) {
            return;
          }
          onClick(e);
        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onFocus={onFocus}
        ref={ref}
        disabled={disabled}
      >
        {icon === 'text' ? (
          props.children
        ) : (
          <div
            className="img"
            style={{
              maskImage: `url('/media/icons/icon-${icon}.svg')`,
              WebkitMaskImage: `url('/media/icons/icon-${icon}.svg')`,
              transform: scale !== 1 ? `scale(${scale})` : undefined
            }}
          />
        )}
      </button>
    );
  }
);



// WEBPACK FOOTER //
// ./src/controller/components/ButtonIcon.tsx